import styled from 'styled-components';

export const FriendsPage = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: stretch;
    padding: 0 50px;
`;

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px;
`;

export const ButtonBack = styled.div`
    border: 0px;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;

    &:before {
        transition: color .4s ease 0s;
        content: '\\F004D';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 25px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: "#fff";
    }
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    height: 30px;
    min-height: 30px;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }
`;

export const Input = styled.input.attrs(()=>({
    type: 'text'
}))`
    background-color: #000;
    border: 1px solid #666;
    height: 30px;
    min-height: 30px;
    width: 200px;
    min-width: 200px;
    box-sizing: border-box;
    padding: 0 5px;
    margin: 0 10px 0 30px;
    color: #fff;
`;

export const Select = styled.select`
    background-color: #000;
    border: 1px solid #666;
    height: 30px;
    min-height: 30px;
    width: 80px;
    min-width: 80px;
    box-sizing: border-box;
    padding: 0 5px;
    margin: 0 10px 0 0;
    color: #fff;
`;


export const FriendItem = styled.div`
    flex: 1;
    min-width: 30%;
    max-width: calc(33% - 20px);
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    cursor: pointer;
    transition: border .4s ease 0s;

    &:nth-child(3n) {
        margin-right: 0;
    }

    
    &.friend {
        border: 1px solid #999;
    }
    &.friend:hover {
        border: 1px solid #F5802E;
    }

    &.pending,
    &.invited {
        border: 1px dashed #999;
    }
    &.pending:hover,
    &.invited:hover {
        border: 1px dashed #F5802E;
    }
`;

export const FriendLetter = styled.div.attrs(p => ({
    style: {
        backgroundColor: p.bgColor || '#000',
        color: p.fgColor || '#fff',
    }
}))`
    font-size: 40px;
    height: 80px;
    min-height: 80px;
    width: 80px;
    min-width: 80px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 50%;
        background: #222;
        background: linear-gradient(90deg, rgba(34,34,34,0) 0%, rgba(34,34,34,1) 100%);
    } 
`;

export const FriendData = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    width: 100%;
`;

export const FriendName = styled.div`
    color: #fff;
    font-size: 16px;
    margin-bottom: 10px;
    transition: color .4s ease 0s;

    ${FriendItem}:hover & {
        color: #F5802E;
    }
`;

export const FriendCommonTable = styled.div`
    color: #999;
    font-size: 12px;
    position: relative;
    padding-left: 20px;

    &:before {
        color: #999;
        font-size: 20px;
        content: '\\F000E';
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const FriendInvited = styled.div`
    color: #999;
    font-size: 12px;
`;

export const FriendRequest = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-right: 10px;
`;

export const FriendRequestLabel = styled.div`
    color: #999;
    font-size: 12px;
`;

export const FriendRequestButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;

export const ConfirmMessage = styled.div`
    font-size: 14px;
    margin-right: 20px;
    color: #fff;
`;

export const UserProfilePage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding: 0 50px 50px;
    box-sizing: border-box;
`;

export const UserHeader = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const UserInfo = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const UserLetter = styled.div.attrs(p => ({
    style: {
        backgroundColor: p.bgColor || '#000',
        color: p.fgColor || '#fff',
    }
}))`
    width: 80px;
    height: 80px;
    min-width: 80px;
    min-height: 80px;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const UserNamesGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    padding: 0 30px;
`;

export const UserName = styled.div`
    font-size: 20px;
    color: #fff;
    margin-bottom: 10px;
`;

export const UserLabel = styled.div`
    font-size: 14px;
    color: #999;
    width: 60px;
    min-width: 60px;

    &.large {
        width: 80px;
        min-width: 80px;
    }
`;

export const UserLabelLine = styled.div`
    font-size: 14px;
    color: #999;
    flex: 1;
    margin-bottom: 10px;
    
    &.spaced {
        margin-top: 20px;
    }
`;

export const UserDataColumn = styled.div`
    width: 47%;
    max-width: 47%;
    margin-right: 6%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;

    &:nth-child(2) {
        margin-right: 0;
    }
`;

export const UserDataGeneralGroup = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
    flex-wrap: wrap;
`;

export const UserDataGroupTags = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
`;

export const UserDataField = styled.div`
    flex: 1;
    min-width: 50%;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
    margin-top: 20px;

    &.compact {
        margin-top: 5px;
    }


`;

export const UserValue = styled.div`
    flex: 1;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &.off {
        opacity: 0.2;
    }
`;

const Icon = styled.div`
    width: 24px;
    height: 24px;
    position: relative;
    margin-right: 5px;

    &:before {
        font: 24px 'Material Design Icons';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const Checked = styled(Icon)`
    &:before {
        content: '\\F05E1';
        color: #0c0;
    }
    `;

export const Unchecked = styled(Icon)`
    &:before {
        content: '\\F015A';
        color: #f33;
    }
`;

export const ContactIcon = styled.div`
    width: 24px;
    height: 24px;
    margin-right: 5px;
    background: url('/app/contact.png') no-repeat 0 0;

    &.whatsapp {
        background-position: -25px 0;
    }
    &.telegram {
        background-position: -50px 0;
    }
    &.discord {
        background-position: -74px 0;
    }
    &.facebook {
        background-position: -100px 0;
    }
    &.instagram {
        background-position: -124px 0;
    }
    &.twitter {
        background-position: -149px 0;
    }
`;

export const SectionTitle = styled.div`
    margin: 30px 0 10px;
    font-size: 20px;
    color: #999;
`;

export const UserAvailable = styled.div`
    font-size: 14px;
    color: #fff;
    padding-left: 30px;
    margin-top: 20px;

    span {
        color: #0c0;
    }
`;

export const UserAvailableObs = styled.div`
    font-size: 14px;
    color: #fff;
    padding: 10px 0 0 30px;
`;

export const UserTabs = styled.div`
    width: 100%;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #999;
`;

export const UserTab = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    cursor: pointer;
    height: 40px;
    margin-bottom: -1px;
    border: 1px solid transparent;
    border-bottom: 1px solid #999;
    border-top: 3px solid transparent;

    &.selected {
        border: 1px solid #999;
        border-bottom: 1px solid #333;
        border-top: 3px solid #999;
    }
`;

export const Tag = styled.div.attrs(p => ({
    style: {
        borderColor: p.color ?? '#fff',
    }
}))`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 7px;
    height: 35px;
    margin-right: 5px;
    margin-bottom: 10px;
    border-width: 3px;
    border-style: solid;
    border-radius: 17px;
    color: #fff;
    font-size: 14px;
`;

export const UserDataTagsRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 20px;
`;

export const UserDataNotValue = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    color: #666;
`;

export const None = styled.div`
    color: #888;
    font-style: italic;
    font-size: 14px;
`;

export const Label = styled.div`
    margin: 0 10px 0 20px;
    color: #888;
    font-size: 16px;
`;